<template>
	<div class="transactional-emails-wrapper height-100">
		<Row class="header flex-justify-space-between width-100 pa-1">
			<h2 class="font-size-lg font-weight-500 pt-1">Preview</h2>
			<Row class="px-2">
				<div @click="openChangeTemplateDialog" class="change-template-btn text-underline cursor-pointer">Change template</div>
				<div class="cursor-pointer header-btn">Edit</div>
				<div class="cursor-pointer header-btn">Send test...</div>
			</Row>
		</Row>
		<Col class="main-template-background">
			<Col class="main-template-content">
				<div style="white-space: pre-wrap">{{ processedTemplateValue }}</div>
				<div class="bottom">
					<div class="line my-2"></div>
					<!-- The following `report` div will actually depend on the account's 
					plan, so it should be conditionally rendered. If they didn't pay for it to be disabled
					they will have the 'We run on Ply badge' -->
					<div class="cursor-pointer report-button-preview py-1">Didn’t expect this email? Report it</div>
					<AppIcon class="processes-on-ply pt-2" name="processes-on-ply" />
				</div>
			</Col>
		</Col>
	</div>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { setSelectedEmailTemplateId } from '@/store/modules/transactionalEmailTemplate/actions';
import { selectedEmailTemplateId, useEmailTemplate } from '@/store/modules/transactionalEmailTemplate/getters';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';

const replaceWithObjectValues = (template, replacements) => {
	let result = template;
	for (const key in replacements) {
		const regex = new RegExp('{{' + key + '}}', 'g');
		if (replacements[key].trim()) {
			result = result.replace(regex, replacements[key]);
		}
	}
	return result;
};

// These need to be rendered as v-html ? They're rich text

export default {
	name: 'TransactionalEmailTabLayout',
	components: {},
	props: { processedEmailTemplateParams: { type: Object } },
	computed: {
		...mapGettersShorthand({ selectedEmailTemplateId, useEmailTemplate }),
		processedTemplateValue() {
			return replaceWithObjectValues(this.selectedTemplateText, this.processedEmailTemplateParams);
		},
		defaultTemplateText() {
			return this.selectedTemplateText;
		},
		selectedTemplateText() {
			const template = this.useEmailTemplate(this.selectedEmailTemplateId);
			return template.text;
		},
	},
	methods: {
		...mapActionsShorthand({ setSelectedEmailTemplateId }),
		async openChangeTemplateDialog() {
			const dialogRes = await AppDialogManagerService.openChangeEmailTemplateDialog();
			if (dialogRes?.id) {
				this.setSelectedEmailTemplateId(dialogRes.id);
			}
		},
	},
};
</script>

<style scoped lang="scss">
.bottom {
	// Could change to use space-between in Col
	position: absolute;
	bottom: 4vh;
}
.processes-on-ply {
	justify-content: flex-start;
	margin-left: -1% !important;
}
.report-button-preview {
	color: #646e87;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 100%;
	text-decoration-line: underline;
}
.line {
	width: 310px;
	height: 1px;
	background: #e0e2e7;
}
.change-template-btn {
	color: #6762f0;
	padding-top: 6px;
}
.header {
	border-bottom: 2px solid #e4e8f3;
	padding-bottom: 12px !important;
}
.header-btn {
	margin-left: 15px;
	padding-top: 6px;
	padding-bottom: 4px;
	padding-right: 10px;
	padding-left: 10px;
	border: solid 1px #6060f7;
	border-radius: 8px;
	color: #6060f7;
	min-width: 80px;
	text-align: center;
}

.main-template-background {
	.main-template-content {
		padding-right: 35px;
		padding-left: 35px;
		padding-top: 30px;
		// padding-bottom: 30px; // .bottom div has position absolute so this has no effect
		background: white;
		height: 90%;
	}
	font-size: 18px;
	padding-top: 45px;
	padding-right: 30px;
	padding-left: 30px;
	background: #f2f5f7;
	height: 100%;
}
</style>
